import { RemoteAgentPresenceIcon } from '../../app/content/RemoteAgentPresenceIcon';
import { IRemoteQueryAgent } from '../../settings/types/ISiteSettingsForSiteAdmin';
import { Module } from '../Module';

export interface IActiveLiveQueryRemoteAgentsFilter {
  (agents: IRemoteQueryAgent[], remoteAgentPresenceIconProperties: _.Dictionary<RemoteAgentPresenceIcon.Props>): IRemoteQueryAgent[];
}

Module.instance().filter('activeLiveQueryRemoteAgentsFilter', [
  '$translate',
  ($translate: ng.translate.ITranslateService): IActiveLiveQueryRemoteAgentsFilter => {
        return (agents: IRemoteQueryAgent[], remoteAgentPresenceIconProperties: _.Dictionary<RemoteAgentPresenceIcon.Props>) => {
            const results = [];
            for (let i = 0; i < agents.length; i++) {
                const agent = agents[i];
                if (agent.pooled && remoteAgentPresenceIconProperties &&
                    (remoteAgentPresenceIconProperties[agent.agentName].currentState === 'CONNECTED' ||
                     remoteAgentPresenceIconProperties[agent.agentName].currentState === 'THROTTLED')){
                    results.push(agent);
                }
            }
            return results;
        };
    }
]);
